import {
  ArrowCircleDown as ArrowCircleDownIcon,
  ArrowCircleUp as ArrowCircleUpIcon,
  LockOutlined as PrivateIcon,
  PublicOutlined as PublicIcon,
} from "@mui/icons-material";
import { Grid, IconButton, Tooltip, Typography } from "@mui/material";
import type { FC } from "react";
import { AssociatedFilesView } from "../../components/associatedFiles/AssociatedFilesView";
import EntityCard from "../../components/entityCard/EntityCard";
import { LastNotes } from "../../components/entityCard/LastNotes";
import type { Note } from "../../components/notes/Notes";
import SimpleNotes from "../../components/notes/SimpleNotes";
import { useUpdatePackageNotes } from "./useUpdatePackageNotes";
interface Package {
  readonly id: { readonly id: string; readonly userFriendlyId: string | null };
  readonly name: string;
  readonly files: { readonly name: string; readonly url: string }[];
  readonly isPublic?: boolean;
  readonly notes: Note[];
}

export interface Props {
  readonly value: Package;
  readonly isFirst: boolean;
  readonly isLast: boolean;
  readonly onClick: (id: string) => void;
  readonly onContextMenu: (id: string) => void;
  readonly onMoveUp: () => void;
  readonly onMoveDown: () => void;
}

const RightComponent = ({
  value,
  isFirst,
  isLast,
  onMoveDown,
  onMoveUp,
}: Pick<Props, "value" | "isFirst" | "isLast" | "onMoveDown" | "onMoveUp">) => (
  <span
    style={{
      display: "flex",
      alignItems: "center",
      width: "100%",
    }}
  >
    <LastNotes notes={value.notes} />

    <span style={{ marginLeft: "auto", display: "flex" }} onClick={(e) => e.stopPropagation()}>
      <IconButton aria-label="Przesuń w górę" size="small" disabled={isFirst} onClick={onMoveUp}>
        <ArrowCircleUpIcon />
      </IconButton>

      <IconButton aria-label="Przesuń w dół" size="small" disabled={isLast} onClick={onMoveDown}>
        <ArrowCircleDownIcon />
      </IconButton>
    </span>
  </span>
);

const PackageCard: FC<Props> = ({ value, onContextMenu, onClick, isFirst, isLast, onMoveUp, onMoveDown }) => {
  const { updatePackageNotes } = useUpdatePackageNotes(value.id.id);
  const onNotesChange = async (notes: Note[]) => {
    await updatePackageNotes(notes);
  };
  return (
    <EntityCard
      role="ADMIN"
      alignChildren="center"
      onClick={() => onClick(value.id.id)}
      onContextMenu={() => onContextMenu(value.id.id)}
      rightHandSideComponent={
        <RightComponent value={value} isFirst={isFirst} isLast={isLast} onMoveDown={onMoveDown} onMoveUp={onMoveUp} />
      }
      rightHandSideComponentExpandable
      rightHandSideComponentSize={5}
      expandableComponent={<SimpleNotes notes={value.notes} onChange={onNotesChange} />}
    >
      <Grid size={6}>
        <Typography variant="subtitle1">
          {" "}
          {value.id.userFriendlyId} • {value.name}
        </Typography>
      </Grid>
      <Grid size={1}>
        {value.isPublic ? (
          <Tooltip title="publiczny">
            <PublicIcon />
          </Tooltip>
        ) : (
          <Tooltip title="prywatny">
            <PrivateIcon />
          </Tooltip>
        )}
      </Grid>
      <Grid size={5}>
        <AssociatedFilesView values={value.files} />
      </Grid>
    </EntityCard>
  );
};

export default PackageCard;
